module.exports = __webpack_public_path__ + "static/img/prize03.4fd09487.png";